import { useId } from 'react';
import { US_STATES } from './types.js';

interface Opt { id: string; label: string }

export function RadioGroup({ legend, options, value, onChange, error }: {
  legend: string;
  options: readonly Opt[];
  value: string;
  onChange: (id: string) => void;
  error?: string;
}) {
  const name = useId();
  return (
    <fieldset className="flex flex-col gap-2">
      <legend className="field-label">{legend}</legend>
      <div className="flex flex-col gap-2">
        {options.map((o) => (
          <label key={o.id} className="inline-flex items-center gap-2 cursor-pointer">
            <input type="radio" name={name} checked={value === o.id} onChange={() => onChange(o.id)} />
            <span>{o.label}</span>
          </label>
        ))}
      </div>
      {error ? <span className="text-[0.8rem] text-status-error dark:text-red-400">{error}</span> : null}
    </fieldset>
  );
}

export function CheckboxGroup({ legend, options, values, onToggle, error }: {
  legend: string;
  options: readonly Opt[];
  values: string[];
  onToggle: (id: string) => void;
  error?: string;
}) {
  return (
    <fieldset className="flex flex-col gap-2">
      <legend className="field-label">{legend}</legend>
      <div className="flex flex-col gap-2">
        {options.map((o) => (
          <label key={o.id} className="inline-flex items-center gap-2 cursor-pointer">
            <input type="checkbox" checked={values.includes(o.id)} onChange={() => onToggle(o.id)} />
            <span>{o.label}</span>
          </label>
        ))}
      </div>
      {error ? <span className="text-[0.8rem] text-status-error dark:text-red-400">{error}</span> : null}
    </fieldset>
  );
}

export function StateSelect({ value, onChange }: {
  value: string;
  onChange: (id: string) => void;
}) {
  return (
    <select className="input" value={value} onChange={(e) => onChange(e.target.value)}>
      <option value="" disabled>Select a state…</option>
      {US_STATES.map((s) => <option key={s.id} value={s.id}>{s.label}</option>)}
    </select>
  );
}
